<template>
  <div>
    <BlTextAv weight="bold" variation="body-16" class="p-16" tag="h2">3 langkah ikutan kelas Prakerja</BlTextAv>
    <BlFlexContainerMv direction="column" padding="8px 16px" class="relative">
      <div class="line absolute"></div>
      <BlFlexContainerMv direction="row" align-items="center" margin="0 0 12px 0" class="relative">
        <BlFlexItemAv margin="0 16px 0 0">
          <IcoComputer />
        </BlFlexItemAv>
        <BlFlexItemAv shrink="1">
          <BlTextAv variation="body-14">
            Daftar di
            <BlTextAv href="https://www.prakerja.go.id/" link-style="primary" rel="nofollow" weight="semi-bold" class="qa-link-prakerja">
              prakerja.go.id
            </BlTextAv>
            buat dapet nomor Prakerja.
          </BlTextAv>
        </BlFlexItemAv>
      </BlFlexContainerMv>

      <BlFlexContainerMv direction="row" align-items="center" margin="12px 0 12px 0" class="relative">
        <BlFlexItemAv margin="0 16px 0 0">
          <IcoBukaiklan />
        </BlFlexItemAv>
        <BlFlexItemAv shrink="1">
          <BlTextAv variation="body-14">Pilih kelas di Bukalapak lalu isi nomor Prakerja.</BlTextAv>
        </BlFlexItemAv>
      </BlFlexContainerMv>

      <BlFlexContainerMv direction="row" align-items="center" margin="12px 0 12px 0" class="relative">
        <BlFlexItemAv margin="0 16px 0 0">
          <IcoVerify />
        </BlFlexItemAv>
        <BlFlexItemAv shrink="1">
          <BlTextAv variation="body-14">Selesaikan kelas dan dapatkan sertifikat maksimal 7 hari.</BlTextAv>
        </BlFlexItemAv>
      </BlFlexContainerMv>
    </BlFlexContainerMv>

    <BlFlexContainerMv direction="row" padding="16px" class="relative" style="border-top: 1px solid #ebebeb">
      <BlFlexItemAv margin="0 16px 0 0">
        <IcoBook color="#3D3D3D" />
      </BlFlexItemAv>
      <BlFlexItemAv shrink="1">
        <BlTextAv variation="body-14">
          Perlu bantuan atau info lebih lanjut?
          <br />
          <BlTextAv
            href="https://bukabantuan.bukalapak.com/"
            rel="nofollow"
            link-style="primary"
            weight="semi-bold"
            class="qa-link-bukabantuan"
          >
            Klik di sini
          </BlTextAv>
          Atau
          <router-link to="/faq" class="qa-link-faq bl-link bl-link:hover">Lihat yang sering ditanyakan</router-link>
        </BlTextAv>
      </BlFlexItemAv>
    </BlFlexContainerMv>
  </div>
</template>

<script>
import {BlFlexContainerMv, BlFlexItemAv, BlTextAv} from '@bukalapak/bazaar-mweb-latest';
import {IcoBook} from '@bukalapak/bazaar-visual-next';
import IcoComputer from 'public/images/kartu-prakerja/guidance-1-computer.svg';
import IcoBukaiklan from 'public/images/kartu-prakerja/guidance-2-bukaiklan.svg';
import IcoVerify from 'public/images/kartu-prakerja/guidance-3-verify.svg';

export default {
  name: 'PrakerjaGuidance',
  components: {
    BlFlexContainerMv,
    BlFlexItemAv,
    BlTextAv,
    IcoBook,
    IcoComputer,
    IcoBukaiklan,
    IcoVerify,
  },
};
</script>

<style scoped>
.line {
  width: 2px;
  height: 50%;
  background: #ebf2fa;
  left: 35px;
  top: 20%;
}
p {
  line-height: 1.5;
}
</style>
